<div
  #zoomParentContainer
  class="h-full w-full flex items-center justify-center"
>
  <div
    #zoomContainer
    class="relative overflow-hidden pointer-events-none"
    [style.width.px]="this.thumbWidth"
    [style.height.px]="this.thumbHeight"
    (mouseleave)="onMouseLeave()"
    (mousemove)="onMouseMove($event)"
    (click)="onClick($event)"
    (keyup)="(null)"
  >
    @if (_imgUrl) {
      <img
        #imageThumbnail
        class="pointer-events-auto object-contain"
        [ngSrc]="_imgUrl"
        [alt]="altText"
        fill
        priority
        (load)="onThumbImageLoaded()"
      />
    }
    <div
      [ngClass]="[
        'absolute overflow-hidden pointer-events-none',
        this.enableLens ? 'zoom__lens' : '',
      ]"
      [style.display]="this.zoomDisplay"
      [style.top.px]="this.lensTop"
      [style.left.px]="this.lensLeft"
      [style.width.px]="this.lensWidth"
      [style.height.px]="this.lensHeight"
    >
      <img
        #fullSizeImage
        class="absolute pointer-events-none max-w-none max-h-none"
        [alt]="altText"
        [src]="_imgUrl"
        (load)="onFullImageLoaded()"
        [style.display]="this.zoomDisplay"
        [style.top.px]="this.fullImageTop"
        [style.left.px]="this.fullImageLeft"
        [style.width.px]="this.magnifiedWidth"
        [style.height.px]="this.magnifiedHeight"
      />
    </div>
  </div>
</div>
